import axios from 'axios';
import authHeader from './auth-header';
import CommonServices from './common.service';

const API_URL = CommonServices.getApiUrl() + 'cook';

class CookService {

  list(foodType) {
    return axios.get(API_URL, { headers: authHeader(), params: { foodType: foodType || undefined } });
  }

  foodTypes() {
    return axios.get(API_URL + '/food_types', { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + '/' + id, { headers: authHeader() });
  }

  saveNotes(id, notes) {
    return axios.put(API_URL + '/' + id + '/notes', { notes }, { headers: authHeader() });
  }

  fit(id, modelVersion) {
    return axios.post(API_URL + '/' + id + '/fit', { modelVersion }, { headers: authHeader() });
  }

  plannedMealCandidates(id) {
    return axios.get(API_URL + '/' + id + '/planned_meal/candidates', { headers: authHeader() });
  }

  linkPlannedMeal(id, plannedMealId, portionsMade) {
    return axios.put(API_URL + '/' + id + '/planned_meal', { plannedMealId, portionsMade },
      { headers: authHeader() });
  }

  unlinkPlannedMeal(id) {
    return axios.delete(API_URL + '/' + id + '/planned_meal', { headers: authHeader() });
  }

  rebuildPriors(modelVersion) {
    return axios.post(API_URL + '/priors/rebuild', { modelVersion }, { headers: authHeader() });
  }
}

export default new CookService();
